<template>
  <div class="m-card">
    <div style="display: flex; justify-content: space-between">
      <div style="font-size: 1.5em; font-weight: bold; color: #32c040">
        Visitor Information
      </div>
      <div>
        <span
          class="material-icons"
          style="color: #32c040; cursor: pointer"
          @click="gotoedit"
        >
          settings
        </span>
      </div>
    </div>
    <div
      style="display: flex; justify-content: space-around"
      class="mb-5 flex-vertical"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-direction: column;
        "
      >
        <div style="display: flex; flex-direction: column">
          <div style="text-align: center; font-weight: 700">
            Scan Tag Barcode
          </div>
          <div style="display: flex; align-items: center; gap: 10px">
            <div
              style="
                border: 1px solid #707070;
                border-radius: 20px;
                padding: 5px;
                display: flex;
                align-items: center;
              "
            >
              <span class="material-symbols-outlined"> barcode_scanner </span>
            </div>
            <div>
              <b-form-input
                v-model="infoTag.mac"
                placeholder="Enter Tag"
                disabled
              ></b-form-input>
            </div>
          </div>
        </div>
        <!-- <div
          style="
            font-size: 1.5em;
            color: #32c040;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          Then
        </div>
        <div style="display: flex; flex-direction: column">
          <b-button variant="outline-primary">Camera</b-button>
        </div> -->
      </div>
      <div style="display: flex; gap: 10px">
        <div style="display: flex; align-items: center">
          <img
            v-if="img == null"
            src="@/assets/images/card id.png"
            alt="img"
            width="150"
          />
          <img v-else :src="img" alt="" srcset="" width="150" />
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          "
        >
          <div
            v-for="(item, i) in info"
            :key="i"
            style="display: flex; gap: 20px; align-items: center"
          >
            <div style="font-size: 1.5em; font-weight: bold">
              {{ item.title }}
            </div>
            <div
              style="font-size: 1.5em; font-weight: 700"
              :style="{ color: item.color }"
            >
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-card mb-3">
      <b-form>
        <b-row class="m-0">
          <b-col class="pr-2">
            <b-form-group
              id="input-group-2"
              label="Company"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="infoTag.company"
                type="text"
                placeholder="Company"
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="pr-2">
            <b-form-group
              id="input-group-3"
              label="Department"
              label-for="input-3"
            >
              <b-form-input
                id="input-3"
                v-model="infoTag.department"
                type="text"
                placeholder="Department"
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-4"
              label="Acknowledged Timestamp"
              label-for="input-4"
            >
              <div style="display: flex; align-items: flex-start; gap: 5px">
                <!-- <b-form-datepicker
                  id="example-datepicker"
                  v-model="value"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-timepicker
                  v-model="value"
                  :hour12="false"
                ></b-form-timepicker> -->
                <b-form-input
                  id="input-4"
                  v-model="infoTag.ack"
                  type="text"
                  placeholder="Acknowledged Timestamp"
                  required
                  disabled
                ></b-form-input>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col class="pr-2">
            <b-form-group
              id="input-group-5"
              label="Visitor Target Location"
              label-for="input-5"
            >
              <b-form-select
                id="input-5"
                v-model="infoTag.target"
                :options="options_location"
                disabled
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col class="pr-2">
            <b-form-group
              id="input-group-6"
              label="Limit Duration Time"
              label-for="input-6"
            >
              <b-form-select
                id="input-6"
                v-model="infoTag.limit"
                :options="options_duration_time"
                disabled
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-7"
              label="Time Limit"
              label-for="input-7"
            >
              <div style="display: flex; align-items: flex-start; gap: 5px">
                <!-- <b-form-datepicker
                  id="example-datepicker"
                  v-model="value"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-timepicker
                  v-model="value"
                  :hour12="false"
                ></b-form-timepicker> -->
                <b-form-input
                  id="input-7"
                  v-model="infoTag.timelimit"
                  type="text"
                  placeholder="Time Limit"
                  required
                  disabled
                ></b-form-input>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <div>
      <b-tabs content-class="mt-3" nav-class="nav-tab">
        <b-tab title="First">
          <template #title>
            <div class="label-tabs">
              <span
                class="material-icons-outlined"
                style="font-size: 16px; font-weight: 100"
              >
                format_list_bulleted
              </span>
              History List
            </div>
          </template>
          <div>
            <b-table striped hover :items="table_list" :fields="fields">
              <template #cell(firstdate)="data">
                {{
                  data.item.firstdate == null
                    ? ""
                    : data.item.firstdate.split("T").join(" ").slice(0, 16)
                }}
              </template>
              <template #cell(lastdate)="data">
                {{
                  data.item.lastdate == null
                    ? ""
                    : data.item.lastdate.split("T").join(" ").slice(0, 16)
                }}
              </template>
              <template #cell(duration)="data">
                {{ data.item.duration == null ? 0 : data.item.duration }} min.
              </template>
            </b-table>
          </div>
        </b-tab>
        <b-tab title="Second" active>
          <template #title>
            <div class="label-tabs">
              <span
                class="material-icons"
                style="font-size: 16px; font-weight: 100"
              >
                event_note
              </span>
              History Chart
            </div>
          </template>
          <div>
            <time-line-chart :chartOptions="chartOptions" :series="series" />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import TimeLineChart from "../../../../components/ApexChart/TimeLineChart.vue";
export default {
  components: { TimeLineChart },
  data() {
    return {
      info: [
        {
          key: "mac",
          title: "Tag ID:",
          value: "2134109423573",
          color: "#646671",
        },
        {
          key: "visitor",
          title: "Visitor Name:",
          value: "MR.Surasak",
          color: "#646671",
        },
        {
          key: "",
          title: "Current Status:",
          value: "Check out",
          color: "#EE5A69",
        },
      ],
      selected_location: null,
      options_location: [
        { value: "", text: "Please select an option" },
        { value: "lobby", text: "Lobby" },
        { value: "meeting_room_1", text: "Meeting Room 1" },
        { value: "meeting_room_2", text: "Meeting Room 2" },
      ],
      selected_duration_time: null,
      options_duration_time: [
        { value: "", text: "Please select an option" },
        { value: "60", text: "1 hr." },
        { value: "120", text: "2 hrs." },
        { value: "180", text: "3 hrs." },
        { value: "240", text: "4 hrs." },
      ],
      table_list: [
        {
          duration: 15,
          firstdate: "2022-09-08T14:09:45.000Z",
          gateway: "AC233FC064BF",
          id: "328",
          lastdate: "2022-09-08T14:25:47.000Z",
          mac: "BC5729000351",
          visitor: "test1",
        },
      ],
      chartOptions: {
        chart: {
          height: 450,
          type: "rangeBar",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "80%",
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            //   datetimeFormatter: {
            //     year: 'yyyy',
            //     month: 'MMM \'yy',
            //     day: 'dd MMM',
            //     hour: 'HH:mm'
            //   }
          },
        },
        stroke: {
          width: 1,
        },
        fill: {
          type: "solid",
          opacity: 0.6,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
        tooltip: {
          x: {
            show: true,
            format: "HH:mm",
            formatter: undefined,
          },
        },
      },
      series: [
        {
          name: "Bob",
          data: [
            // {
            //   x: "29-07-2022",
            //   y: [
            //     +this.$moment().subtract(2, "hours"),
            //     +this.$moment().subtract(0, "hours"),
            //   ],
            // },
            // {
            //   x: "29-07-2022",
            //   y: [
            //     +this.$moment().subtract(6, "hours"),
            //     +this.$moment().subtract(4, "hours"),
            //   ],
            // },
            // {
            //   x: "28-07-2022",
            //   y: [
            //     +this.$moment().subtract(2, "hours"),
            //     +this.$moment().subtract(1, "hours"),
            //   ],
            // },
            // {
            //   x: "28-07-2022",
            //   y: [
            //     +this.$moment().subtract(5, "hours"),
            //     +this.$moment().subtract(3, "hours"),
            //   ],
            // },
            // {
            //   x: "28-07-2022",
            //   y: [
            //     +this.$moment().subtract(7, "hours"),
            //     +this.$moment().subtract(6, "hours"),
            //   ],
            // },
            // {
            //   x: "27-07-2022",
            //   y: [
            //     +this.$moment().subtract(6, "hours"),
            //     +this.$moment().subtract(3, "hours"),
            //   ],
            // },
            // {
            //   x: "27-07-2022",
            //   y: [
            //     +this.$moment().subtract(1, "hours"),
            //     +this.$moment().subtract(0, "hours"),
            //   ],
            // },
          ],
        },
      ],
      img: null,
      infoTag: {
        ack: "2022-08-08T16:23:00.000Z",
        company: "234",
        department: "5234",
        description: "",
        id: "7",
        image: null,
        limit: "120",
        mac: "2425",
        target: "lobby",
        timelimit: "2022-08-08T18:23:00.000Z",
        visitor: "2434",
      },
      fields: [
        {
          key: "visitor",
          label: "Visitor",
        },
        {
          key: "firstdate",
          label: "First Date",
          sortable: false,
        },
        {
          key: "lastdate",
          label: "Last Date",
          sortable: false,
        },
        {
          key: "duration",
          label: "Duration",
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    console.log(+this.$moment(), this.$moment().subtract(2, "hours"));
    // try {
    //   let res = await this.$API.get("indoortaglog");
    //   console.log(res);
    // } catch (error) {}
    let tag = this.$session.get("tag");
    tag.ack = this.$moment(tag.ack)
      .subtract(7, "hours")
      .format("YYYY-MM-DD HH:mm");
    tag.timelimit = this.$moment(tag.timelimit)
      .subtract(7, "hours")
      .format("YYYY-MM-DD HH:mm");
    this.infoTag = tag;

    for (let i = 0; i < this.info.length; i++) {
      const el = this.info[i];
      this.info[i].value = this.infoTag[el.key];
    }

    this.series[0].name = this.infoTag.visitor;

    await this.getImg();
    await this.getDataChart();
  },
  methods: {
    gotoedit() {
      this.$router.push("/mhesi/editprofile");
    },
    async getImg() {
      try {
        let res = await this.$API.get(`downloadMHESI/${this.infoTag.visitor}`);
        console.log(res);
        this.img = res.config.url;
        console.log(this.img);
      } catch (error) {}
    },
    async getDataChart() {
      try {
        let res = await this.$API.get(`indoorassetlog/${this.infoTag.visitor}`);
        console.log(res);
        this.table_list = res.data;
        let today = this.$moment().format("YYYY-MM-DD");
        let new_series = [];
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          if (el.lastdate != null) {
            new_series.push({
              x: el.firstdate.split("T")[0],
              y: [
                +this.$moment(today + "T" + el.firstdate.split("T")[1]),
                +this.$moment(today + "T" + el.lastdate.split("T")[1]),
              ],
            });
          }
        }
        this.series = [{
          data:new_series
        }]
        console.log(this.series);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.label-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3em;
}

@media screen and (max-width: 600px) {
  .flex-vertical {
    flex-direction: column;
    align-items: center;
  }
}
</style>

<style lang="scss">
.nav-tab {
  justify-content: flex-start !important;
  li {
    width: max-content !important;
    flex: none !important;
  }
}
</style>